import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {NgxSpinnerService} from 'ngx-spinner';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MarketplaceCategoryService} from '../../../../core/services/marketplaceCategory.service';
import {FuseConfigService} from '../../../../core/services/config.service';
import {OrganizationsService} from '../../../../core/services/organizations.service';
import {MarketplaceService} from '../../../../core/services/marketplace.service';
import {map, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {PlatformsService} from '../../../../core/services/platforms.service';
import {CheckModalComponent} from '../../check-save-modal/check-modal';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import * as _ from 'lodash';
import {TranslateService} from '@ngx-translate/core';
import {DocumentsService} from '../../../../core/services/documents.service';
import {FuseDeleteDialogComponent} from '../../../../core/components/delete-dialog/delete-dialog.component';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-marketplace-detail',
  templateUrl: './marketplace-detail.component.html',
  styleUrls: ['./marketplace-detail.component.scss'],
  standalone: false
})

export class MarketplaceDetailComponent implements OnInit {
  public id;
  public form = new FormGroup({
    title: new FormControl('', [Validators.required]),
    category: new FormControl(''),
    authorId: new FormControl({value: '', disabled: true}, [Validators.required]),
    authorType: new FormControl('', [Validators.required]),
    type: new FormControl('', [Validators.required]),
    information: new FormControl(''),
    platform: new FormControl(''),
    status: new FormControl('activated'),
    countryId: new FormControl('', Validators.required),
    cityId: new FormControl('', Validators.required),
    organizationId: new FormControl('', Validators.required),
    email: new FormControl(''),
    phone: new FormControl('')
  });
  defaultForm;

  marketplaceCategories;
  userList = [];
  countries = [];
  cities = [];
  organizations = [];
  marketplace;
  filteredOptions!: Observable<any[]>;
  platforms;
  platformId;
  selectedPlatforms = [];
  public returnBack;
  public infoTabOpen = false;
  public mediaTabOpen = false;
  documents: any;
  uploadedDocuments: any;
  pictures: any;
  uploadedPictures: any;
  videos: any;
  uploadedVideos: any;

  constructor(private route: ActivatedRoute, private location: Location,
              private spinner: NgxSpinnerService, public marketplaceCategoryService: MarketplaceCategoryService,
              private fuseConfig: FuseConfigService, private organizationService: OrganizationsService,
              public marketplaceService: MarketplaceService, private platformsService: PlatformsService,
              public snackBar: MatSnackBar, public dialog: MatDialog, public translate: TranslateService,
              private documentService: DocumentsService, private router: Router, public toastr: ToastrService) {
    this.id = this.route.snapshot.queryParamMap.get('id');
    this.fuseConfig.selectedPlatform.subscribe(res => {
      if (res && res.id) {
        this.platformId = res.id;
      }
    });
  }

  canDeactivate(): Observable<boolean> | boolean {
    return this.goBack();
  }

  ngOnInit() {
    this.defaultForm = this.form.getRawValue();
    this.getMarketplaceCategories();
    this.form.controls['authorType'].valueChanges.subscribe((result) => {
      this.checkOrganizationAndUserType();
    });
    this.form.controls['organizationId'].valueChanges.subscribe((result) => {
      this.checkOrganizationAndUserType();
    });

    this.fuseConfig.role.subscribe(res => {
      const selectControlCountry = this.form.get('countryId');
      const selectControlCity = this.form.get('cityId');
      const selectControlOrg = this.form.get('organizationId');
      if (res && res === 'organisationAdmin') {
        selectControlCountry.disable();
        selectControlCity.disable();
        selectControlOrg.disable();
      }
      if (res && res === 'subCountryAdmin') {
        selectControlCountry.disable();
        selectControlCity.disable();
      }
      if (res && res === 'countryAdmin') {
        selectControlCountry.disable();
      }
    });

    this.organizationService.getCountry().subscribe((result: any) => {
      this.countries = result;
      if (this.marketplace) {
        this.form.patchValue({countryId: this.marketplace.countryId});
      }
      if (this.countries.length === 1 && !this.marketplace){
        this.form.patchValue({countryId: this.countries[0].id});
      }
    });

    this.form.get('countryId').valueChanges.subscribe((res) => {
      if (res) {
        this.organizationService.getCity(res).subscribe((result: any) => {
          this.cities = result;
          this.form.patchValue({cityId: null});
          if (this.marketplace) {
            this.form.patchValue({cityId: this.marketplace.cityId});
          }
          if (this.cities.length === 1 && !this.marketplace){
            this.form.patchValue({cityId: this.cities[0].id});
          }
        });
      }
    });

    this.form.get('cityId').valueChanges.subscribe((res) => {
      if (res) {
        this.organizationService.getOrganizationByCity(res).subscribe((result: any) => {
          this.organizations = result;
          this.form.patchValue({organizationId: null});
          if (this.marketplace) {
            this.form.patchValue({organizationId: this.marketplace.organizationId});
          }
          if (this.organizations.length === 1 && !this.marketplace){
            this.form.patchValue({organizationId: this.organizations[0].id});
          }
        });
      }
    });

    this.form.get('organizationId').valueChanges.subscribe((res) => {
      if (res) {
        this.platformsService.getByOrganizationId(res).subscribe(platforms => {
          this.platforms = platforms;
          if (this.marketplace && this.marketplace.platforms) {
            let plat = this.marketplace.platforms.split(',');
            this.selectedPlatforms = plat.map(el => Number(el.replace(/\//g, '')));
          } else if (!this.marketplace && this.platformId) {
            this.selectedPlatforms.push(+this.platformId);
          }
        });
      }
    });

    this.filteredOptions = this.form.get('authorId').valueChanges.pipe(
      startWith(''),
      map((value: any) => {
        const name = typeof value === 'string' ? value : value?.firstName + ' ' + value?.lastName;
        return name ? this._filter(name as string) : this.userList.slice();
      }),
    );
    if (this.id) {
      this.getMarketplace();
    }
  }

  getMarketplace() {
    this.spinner.show();
    this.marketplaceService.getMarketplace(this.id).subscribe({
      next: (result: any) => {
        if (result) {
          result.category = result.category.split(',').map(el => {
            el = el.replace(/\//g, '');
            if (el.indexOf('_sub') === -1) {
              el = Number(el);
            }
            return el;
          });
          this.selectedPlatforms = result.platform.split(',').map(el => Number(el.replace(/\//g, '')));
          this.marketplace = result;
          this.uploadedDocuments = result.documents;
          this.uploadedVideos = result.videos;
          this.uploadedPictures = result.pictures;
          this.form.patchValue(result);
          this.checkUser();
        }
        this.spinner.hide();
      },
      error: (err: any) => {}
    });
  }

  checkUser() {
    if (this.userList?.length && this.marketplace) {
      let user = this.userList.find(us => +us.id === +this.marketplace.authorId);
      if (user) {
        this.form.get('authorId')?.setValue(user);
      }
    }
    this.defaultForm = this.form.getRawValue();
  }

  back () {
    this.location.back();
  }

  goBack(){
    let dialogRef;
    if (!this.returnBack && !_.isEqual(this.form.getRawValue(), this.defaultForm)) {
      dialogRef = this.dialog.open(CheckModalComponent, {
        panelClass: 'unsave-form-dialog'
      });

      return dialogRef.afterClosed().toPromise().then((result: any) => {
        if (result === 'leave') {
          return true;
        } else if (result === 'save') {
          if (this.form.valid && this.selectedPlatforms.length) {
            this.addMarketPlace(false);
            return true;
          } else {
            let text = this.translate.instant('fill_req_field');
            this.snackBar.open(text, '', {duration: 2500});
            return false;
          }
        }
      });
    } else {
      return true;
    }
  }

  changePlatforms(platform) {
    this.selectedPlatforms = platform.value;
  }

  checkOrganizationAndUserType(){
    const selectControlAuthor = this.form.get('authorId');
    if (!!this.form.controls['organizationId'].value && !!this.form.controls['authorType'].value ) {
      selectControlAuthor.enable();
      this.getUsers();
    } else {
      selectControlAuthor.disable();
    }
  }

  getUsers() {
    this.userList = [];
    this.spinner.show();
    this.marketplaceService.getUsers(this.form.controls['authorType'].value, this.form.controls['organizationId'].value )
      .subscribe({
        next: (result) => {
          this.userList = result;
          this.form.get('authorId')?.setValue('');
          this.form.get('authorId')?.updateValueAndValidity({ emitEvent: true });
          this.checkUser();
          this.spinner.hide();
        },
        error: (err) => {
          this.spinner.hide();
        }
      });
  }

  uploadDocuments(documents) {
    this.documents = documents;
  }

  uploadPictures(pictures) {
    this.pictures = pictures;
  }

  uploadVideo(videos) {
    this.videos = videos;
  }

  addMarketPlace(returnBack) {
    if (this.form.valid && this.selectedPlatforms.length) {
      this.spinner.show();
      let obj: any = this.form.getRawValue();
      if (obj?.authorId?.id) {
        obj.authorId = obj.authorId.id;
      }
      if (this.id) {
        obj.id = this.id;
      }
      obj.platform = this.selectedPlatforms.map(el => '/' + el.toString() + '/').join(',');
      obj.category = obj.category.map(el => '/' + el.toString() + '/').join(',');
      this.marketplaceService.addMarketplace(obj).subscribe({
        next: (result: any) => {
          this.returnBack = returnBack;
          if (result) {
            if (this.documents && this.documents.length) {
              let documentData = {
                files: this.documents ,
                type: 'marketplace' ,
                connectedId: result.id
              };
              this.documentService.uploadElDocument(documentData).subscribe((resDoc) => {
              });
            }
            if (this.pictures && this.pictures.length) {
              let documentData = {
                files: this.pictures ,
                type: 'marketplace-picture' ,
                connectedId: result.id
              };
              this.documentService.uploadElDocument(documentData).subscribe((resDoc) => {
              });
            }
            if (this.videos && this.videos.length) {
              for (let video of this.videos) {
                video.connectedId = result.id;
              }
              this.documentService.addBigDocument(this.videos).subscribe((resDoc) => {
              });
            }
          }
          if (result && this.returnBack) {
            this.back();
          }
          this.spinner.hide();
        },
        error: (err) => {
          this.spinner.hide();
        }
      });
    }
  }

  deleteMarketplace() {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.spinner.show();
        this.marketplaceService.deleteMarketplace(this.id).subscribe((res) => {
          this.toastr.success('Marketplace deleted', 'Success!');
          this.router.navigate([ './pages/marketplaces' ]);
          this.spinner.hide();
        });
      }
    });
  }

  getMarketplaceCategories() {
    this.marketplaceCategoryService.getMarketplaceCategory().subscribe((res: any) => {
      this.marketplaceCategories = res;
    });
  }

  selectCat(catId, event) {
    let index = this.marketplaceCategories.findIndex(el => el.id === catId);
    let value: any = this.form.controls['category'].value ? this.form.controls['category'].value : [];
    if (index !== -1) {
      let ids = this.marketplaceCategories[index].marketplaceSubcategory.map((m) => m.id + '_sub');
      if (value.includes(catId)) {
        value = value.concat(ids);
        value = [...new Set(value)];
      } else {
        for (let i = 0; i < ids.length; i++) {
          let indexInValue = value.indexOf(ids[i]);
          if (indexInValue !== -1) {
            value.splice(indexInValue, 1);
          }
        }
        value = [...new Set(value)];
      }
      this.form.patchValue({category: value});
    }
  }

  displayFn(user: any) {
    return user ? (user.firstName + ' ' + user.lastName) : '';
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.userList.filter(option => option.firstName.toLowerCase().includes(filterValue)
      || option.lastName.toLowerCase().includes(filterValue));
  }
}
